module.exports = __webpack_public_path__ + "static/media/pink-lollipop.d85e0b75.jpeg";